import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { FormattedMessage, injectIntl } from 'react-intl'
import { SelectInput } from '../Inputs/Inputs'
import {
  CapitalButton,
} from '../Navigation/Buttons'

import styles from '../../../../css/devicePage.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

function PreferenceTemperatureScale ({ user, backToUser, intl }) {
  const [state, setState] = useState({
    locale: user.data.locale,
    invalid: false,
  })
  const goBackOnce = useRef(false)

  useEffect(() => {
    if (user.saved === true && goBackOnce.current === false) {
      goBackOnce.current = true
      setTimeout(() => {
        backToUser()
      }, 200)
    }
  }, [user.saved, backToUser])

  useEffect(() => () => {
    AppDispatcher.dispatch({
      action: 'unload-user-change',
    })
  }, [])

  const saveButtonFunction = () => {
    appDispatch()
  }

  const appDispatch = () => {
    AppDispatcher.dispatch({
      action: 'update-user',
      userID: user.id,
      change: {
        locale: state.locale,
      },
    })
  }

  const childChange = (event) => {
    handleChange(event.target.name, event.target.value)
  }

  const handleChange = (field, value, callback) => {
    const newState = update(
      state,
      {
        locale: {
          [field]: { $set: value },
        },
        invalid: { $set: false },
      }
    )
    setState(newState)
    if (callback) callback()
  }

  const { formatMessage } = intl
  const options = {
    temperatureScale: [
      {
        value: 'f',
        name: formatMessage({
          id: 'profile.temperatureScale.f',
          defaultMessage: 'Fahrenheit (F)',
          description: '',
        }),
      },
      {
        value: 'c',
        name: formatMessage({
          id: 'profile.temperatureScale.c',
          defaultMessage: 'Celsius (C)',
          description: '',
        }),
      },
    ],
  }

  let saveButtonStyle = `${styles.saveButton} saveButton`
  if (state.invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonHidden}`
  } else if (user.saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (user.saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          <FormattedMessage
            id='profile.temperatureScale.name'
            defaultMessage='Temperature Scale'
            description='Temperature Scale'
          />
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={state.locale.tempConv || 'f'}
            field='tempConv'
            childChange={childChange}
            options={options.temperatureScale}
            style={styles.settingSelectInput}
          />
        </div>
      </section>
      <section>
        <FormattedMessage
          id='setting.save'
          defaultMessage='SAVE'
          description='SAVE label'
        >
          {(txt) => (
            <CapitalButton
              text={txt}
              buttonFunction={saveButtonFunction}
              hSize='h2'
              style={saveButtonStyle}
            />
          )}
        </FormattedMessage>
      </section>
    </div>
  )
}

PreferenceTemperatureScale.propTypes = {
  user: PropTypes.object.isRequired,
  backToUser: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(PreferenceTemperatureScale)
